import 'css-chunksrc/client/common/secondaryCriteriaForm/richTextForm/styles.scss';export default {
  "richTextForm": "_richTextForm_9anqu_1",
  "readOnly": "_readOnly_9anqu_5",
  "preview": "_preview_9anqu_13",
  "previewContent": "_previewContent_9anqu_32",
  "disabled": "_disabled_9anqu_39",
  "popupEditor": "_popupEditor_9anqu_44",
  "popupTitle": "_popupTitle_9anqu_49"
};